import React from 'react'

// import GuideLink from 'components/GuideViewer/GuideLink'
import cpythonlogo from 'images/guides/circuitpython-logo.png';

const title = "Getting Started With Python"

const pages = [
  () => (
    <>
      <h2>Getting Started with Adafruit IO Python</h2>

      <img src={cpythonlogo} className="guide-image center mb-16" />

      <p>Adafruit IO Python makes it simple to get your project&#39;s data into the best data system in the world - <a href="http://io.adafruit.com">Adafruit IO</a>. </p>

      <p>You can send <em>any</em> data from your Python script to Adafruit IO, and retrieve data from Adafruit IO into your Python script. </p>

      <p>Ready to interact with Adafruit IO with Python?</p>
    </>
  ),

  () => (
    <>
      <h2>Installing Adafruit IO Python</h2>

      <p>Before we start, you&#39;ll need Python 3.4 or above installed on Windows, MacOS or Linux hardware. This hardware also needs an active internet connection to connect to Adafruit IO.</p>

      <p>Once you have installed <a href="https://pip.pypa.io/en/stable/installing/">PIP</a>, the Python package management tool, run:</p>

      <pre><code>pip3 install adafruit-io</code></pre>

      <p>This will automatically install the Adafruit IO Python package for your Python scripts to use.</p>
    </>
  ),

  () => (
    <>
      <h2>Interactive Tutorial</h2>

      <p>We have an interactive tutorial if you&#39;d like to try out Adafruit IO Python right from your browser!</p>

      <p><strong>Click here to try it out:</strong> <a href="https://mybinder.org/v2/gh/brentru/adafruit_io_python_jupyter/master?filepath=adafruit-io-python-tutorial.ipynb"><img src="https://img.shields.io/badge/Try%20out-Adafruit%20IO%20Python-F5A252.svg?logo=data:image/png;base64,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" alt="badge" /></a></p>
    </>
  ),

  () => (
    <>
      <h2>More Examples</h2>

      <p>Ready to take Adafruit IO Python to the next level? Need more examples?</p>

      <ul>
        <li><a href="https://github.com/adafruit/Adafruit_IO_Python/tree/master/examples/api">Using Adafruit IO Python with the Adafruit IO API</a></li>
        <li><a href="https://github.com/adafruit/Adafruit_IO_Python/tree/master/examples/mqtt">Using Adafruit IO Python with the  Adafruit IO MQTT API</a></li>
      </ul>
    </>
  ),
  () => (
    <>
      <h2>Adafruit IO Python and CircuitPython</h2>

      <p>If you have a single-board linux computer capable of running CircuitPython using Adafruit_Blinka, you can add Adafruit IO to your project to add remote monitoring of sensors, actuators, NeoPixels and more!</p>

      <p>Not sure where to start? <a href="https://learn.adafruit.com/series/adafruit-io-basics">The Adafruit IO Basics guides all have CircuitPython-compatible code and wiring diagrams.</a></p>
    </>
  ),
  () => (
    <>
      <h2>Learning Guides and Resources</h2>

      <p><a href="https://learn.adafruit.com/category/adafruit-io">The Adafruit Learning System has Adafruit IO projects and guides to inspire your next project!</a></p>
    </>
  ),
]

export {
  title,
  pages
}
